import { dpSharedStyleOnce } from './dp-shared.js'
// 受付ボード（依頼主）。一覧＝SS風、詳細＝ハコベル準拠フォーム。
// 下払い(charterCost)・支払通行料(tollPay)は出さない。配車ボードは別画面のまま。
import { listDocs, getOne, upsert, remove, COLLECTIONS, subscribeChanges } from '../data/collections.js'
import { supabase, supabaseReady } from '../supabase.js'
import { loadVehicleTypes, vehicleTypeInput } from '../data/vehicleTypes.js'
import { sanitizeForCustomer, requestToTrip, mergeEvidenceAttachments, applyListPatch, explainEvidenceError, applyExtractedDraft, coalesceDraft, coalesceDraftWithFilename, draftFromFilename, matchMasterParty, matchVehicleClass, suggestMissingFromHistory, listPlaceLabel } from '../data/intakeCore.js'
import { uploadEvidenceFiles, EVIDENCE_ACCEPT } from '../data/evidenceUpload.js'
import { extractDraftFromPath } from '../data/extractClient.js'
import { openIdFromHash } from '../data/crossLink.js'

const YEN = (n) => '¥' + Math.round(Number(n) || 0).toLocaleString('ja-JP')
const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))
const PREFS = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
const STAFF_BASE = ['片山', '山本', '近藤', '木下', '田中', '伊藤', '深瀬', '仙台営業所']
const pad = (n, l = 2) => String(n).padStart(l, '0')
const randTail = (n) => {
  const cs = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let s = ''
  const buf = (globalThis.crypto && crypto.getRandomValues) ? crypto.getRandomValues(new Uint32Array(n)) : null
  for (let i = 0; i < n; i++) s += cs[(buf ? buf[i] : Math.floor(Math.random() * 36)) % 36]
  return s
}
const newId = (dateStr) => {
  const ymd = /^\d{4}-\d{2}-\d{2}$/.test(dateStr || '')
    ? String(dateStr).slice(2).replace(/-/g, '')
    : (() => { const d = new Date(); return `${pad(d.getFullYear() % 100)}${pad(d.getMonth() + 1)}${pad(d.getDate())}` })()
  return `UK${ymd}${randTail(6)}`
}
const genToken = () => (globalThis.crypto && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}${Math.random().toString(16).slice(2)}`)
const blankStop = (role) => ({ role, name: '', pref: '', city: '', addr: '', bldg: '', date: '', time: '', spec: '', contact: '', tel: '', note: '' })
const stopsOf = (f) => Array.isArray(f.stops) ? f.stops : []
const picksOf = (f) => stopsOf(f).filter((s) => s.role === 'pick')
const dropsOf = (f) => stopsOf(f).filter((s) => s.role === 'drop')
const firstPick = (f) => picksOf(f)[0] || null
const lastDrop = (f) => { const d = dropsOf(f); return d.length ? d[d.length - 1] : null }
const stopAddr = (s) => [s.pref, s.city, s.addr, s.bldg].map((x) => String(x == null ? '' : x).trim()).filter(Boolean).join('') || String(s.name || '').trim()
const originStr = (f) => { const s = firstPick(f); return s ? (listPlaceLabel(s) || stopAddr(s)) : String(f.origin || '').trim() }
const destStr = (f) => { const s = lastDrop(f); return s ? (listPlaceLabel(s) || stopAddr(s)) : String(f.dest || '').trim() }
const runDateOf = (f) => { const s = firstPick(f); return (s && s.date) || f.date || '' }
const field = (label, control, hint) => `<label class="dp-fld"><span class="dp-lab">${esc(label)}</span>${control}${hint ? `<span class="dp-hint">${hint}</span>` : ''}</label>`
const byCode = (a, b) => (Number(a.code) || 0) - (Number(b.code) || 0) || String(a.code || a.id).localeCompare(String(b.code || b.id), 'ja')
const idMap = (arr) => { const m = {}; for (const x of arr) m[x.id] = x; return m }
const publicLink = (token) => {
  const base = `${location.origin}${location.pathname || '/'}`.replace(/index\.html$/i, '')
  return `${base}#/request?token=${encodeURIComponent(token || '')}`
}

const U = {
  el: null, rows: [], form: null, saving: '', online: false, fetchError: false, user: null,
  cust: [], part: [], drv: [], custById: {}, partById: {}, drvById: {}, vtypes: [],
  filter: 'all', q: '', painting: false,
}

function styleOnce() {
  dpSharedStyleOnce()
  if (document.getElementById('uk-style')) return
  const s = document.createElement('style'); s.id = 'uk-style'
  s.textContent = `
  .uk{display:flex;flex-direction:column;gap:12px}
  .uk-bar{display:flex;align-items:center;gap:10px;flex-wrap:wrap}
  .uk-bar input[type=search]{font-family:inherit;font-size:13px;padding:6px 10px;border:1px solid var(--e1);border-radius:8px;min-width:200px}.dp-btn.ok{background:var(--pos);color:var(--bg);border-color:var(--pos)}
  .uk-ss-wrap{border:1px solid var(--e1);border-radius:4px;overflow:auto;max-height:62vh;background:var(--card)}
  table.uk-ss{width:100%;border-collapse:collapse;font-size:12px;font-variant-numeric:tabular-nums}
  .uk-ss th,.uk-ss td{border:1px solid var(--e1);padding:4px 8px;text-align:left;white-space:nowrap;background:var(--card)}
  .uk-ss th{position:sticky;top:0;background:var(--head);color:var(--text);font-size:11px;font-weight:800;z-index:1}
  .uk-ss td.n,.uk-ss th.n{text-align:right}
  .uk-ss tbody tr{cursor:default}
  .uk-ss td input.uk-cell{width:100%;min-width:64px;box-sizing:border-box;border:0;background:transparent;font:inherit;font-size:12px;padding:1px 2px;color:var(--text)}
  .uk-ss td input.uk-cell:focus{outline:2px solid var(--text);background:var(--card);border-radius:2px;color:var(--text)}
  .uk-ss td.n input.uk-cell{text-align:right}
  .uk-pill{font-size:10px;font-weight:800;border-radius:4px;padding:1px 7px;cursor:pointer}
  .uk-ss tbody tr:nth-child(even) td{background:var(--head)}
  .uk-ss tbody tr:hover td{background:transparent}
  .uk-pill.sashi{color:var(--signal);background:transparent}
  .uk-pill.formal{color:var(--pos);background:var(--head)}
  .uk-pill.sent{color:var(--text);background:var(--head)}
  .dp-card.wide{width:min(1120px,97vw)}
  .uk-mail{background:var(--card);border:1px solid var(--e1);border-radius:10px;padding:10px 12px;font-size:12.5px;line-height:1.65;color:var(--text);white-space:pre-wrap}
  .uk-att{display:flex;flex-wrap:wrap;gap:8px;margin-top:8px}
  .uk-att a,.uk-att span{font-size:12px;color:var(--text)}
  .uk-file{font-size:12.5px;margin-top:8px}
  .uk-pend{font-size:12px;color:var(--text);background:var(--head);border-radius:6px;padding:3px 8px;display:inline-block;margin:4px 6px 0 0}
  .uk-draft{background:transparent !important}
  `
  document.head.appendChild(s)
}

function tripStops(t) {
  if (Array.isArray(t.stops) && t.stops.length) {
    return t.stops.map((s) => Object.assign(blankStop(s.role === 'drop' ? 'drop' : 'pick'), {
      name: s.name || '', pref: s.pref || '', city: s.city || '', addr: s.addr || '', bldg: s.bldg || '',
      date: s.date || '', time: s.time || '', spec: s.spec || '', contact: s.contact || '', tel: s.tel || '', note: s.note || '',
    }))
  }
  return [Object.assign(blankStop('pick'), { name: t.origin || '', date: t.date || '' }), Object.assign(blankStop('drop'), { name: t.dest || '', date: t.unloadDate || t.date || '' })]
}
function blankForm() {
  return {
    mode: 'add', kind: 'own', status: 'sashi', token: genToken(), staff: '',
    customerId: '', customerName: '', prime: '存在しない',
    stops: [Object.assign(blankStop('pick'), {}), blankStop('drop')],
    vehicleClass: '', item: '', packing: '', qty: '', weightKg: '', volumeM3: '', slipNo: '', cargoNote: '',
    driverId: '', driverName: '', carNo: '', tel: '', partnerId: '', partnerName: '', carrier: '', youshaDriver: '',
    fare: '', tollBill: '', billFixed: '', salesDate: '', receiptDate: '', memo1: '', memo2: '',
    attachments: [], pendingFiles: [], fromEmail: '', subject: '', bodyText: '', source: 'manual', err: '',
  }
}
function rowToForm(t) {
  const kind = (t.partnerName || t.partnerFormal) ? 'charter' : 'own'
  return {
    mode: 'edit', id: t.id, kind, status: t.status || 'sashi', token: t.token || '', staff: t.staff || '',
    customerId: t.customerId || '', customerName: t.customerFormal || t.customerName || '',
    prime: t.prime || '存在しない', stops: tripStops(t),
    vehicleClass: t.vehicleClass || '', item: t.item || '', packing: t.packing || '',
    qty: t.qty != null ? t.qty : '', weightKg: t.weightKg != null ? t.weightKg : '', volumeM3: t.volumeM3 != null ? t.volumeM3 : '',
    slipNo: t.slipNo || '', cargoNote: t.cargoNote || '',
    driverId: t.driverId || '', driverName: t.driverName || '', carNo: t.carNo || '', tel: t.tel || '',
    partnerId: t.partnerId || '', partnerName: t.partnerFormal || t.partnerName || '', carrier: t.carrier || '', youshaDriver: t.youshaDriver || '',
    fare: t.fare ? t.fare : '', tollBill: t.tollBill ? t.tollBill : '',
    billFixed: t.billFixed || '', salesDate: t.salesDate || '', receiptDate: t.receiptDate || '', memo1: t.memo1 || '', memo2: t.memo2 || '',
    attachments: t.attachments || [], pendingFiles: [], fromEmail: t.fromEmail || '', subject: t.subject || '', bodyText: t.bodyText || '',
    source: t.source || 'manual', tripId: t.tripId || '', err: '',
  }
}
function statusLabel(st, tripId) {
  if (tripId) return { k: 'sent', t: '配車済' }
  if (st === 'formal') return { k: 'formal', t: '正式' }
  return { k: 'sashi', t: '仮受付' }
}

function requiredItems(f) {
  return [
    ['荷主', !!String(f.customerName || '').trim(), 'sec-nushi'],
    ['発地', picksOf(f).some((s) => stopAddr(s)), 'sec-route'],
    ['着地', dropsOf(f).some((s) => stopAddr(s)), 'sec-route'],
    ['運行日', !!runDateOf(f), 'sec-route'],
    ['車種', !!String(f.vehicleClass || '').trim(), 'sec-sha'],
    ['品名', !!String(f.item || '').trim(), 'sec-nimotsu'],
    ['運賃', Number(f.fare) > 0, 'sec-kingaku'],
  ]
}
function missingRequired(f) {
  return requiredItems(f).filter((x) => !x[1]).map((x) => x[0])
}

function sidePanel(f) {
  const items = requiredItems(f)
  const miss = items.filter((x) => !x[1])
  const rows = items.map(([k, ok, go]) => `<div class="dp-goto" data-goto="${go}"><span>${esc(k)}</span><span class="st ${ok ? 'ok' : 'no'}">${ok ? '✓ 入力済' : '未入力'}</span></div>`).join('')
  return `
    ${f.err ? `<div class="dp-err">${esc(f.err)}</div>` : ''}
    ${miss.length ? `<div class="dp-side-warn">⚠ 未入力 ${miss.length}（仮の保存は可。取込は不可）</div>` : '<div class="dp-side-ok">✓ 必要項目は入力済み</div>'}
    <div class="dp-side-box">${rows}</div>
    <div class="dp-side-sum">
      <div class="cap">受付</div>
      <div class="r" style="display:flex;justify-content:space-between;margin-top:7px"><span>状態</span><span>${esc(statusLabel(f.status, f.tripId).t)}</span></div>
      <div class="r" style="display:flex;justify-content:space-between;margin-top:7px"><span>運賃</span><span>${YEN(f.fare)}</span></div>
    </div>`
}

function renderForm() {
  const f = U.form, own = f.kind === 'own'
  const staffOpts = [...new Set([...STAFF_BASE, f.staff].filter(Boolean))]
  const prefSel = (i, sel) => `<select data-stop="${i}" data-sf="pref"><option value="">選択</option>${PREFS.map((x) => `<option value="${x}"${sel === x ? ' selected' : ''}>${x}</option>`).join('')}</select>`
  const specSel = (i, sel) => `<select data-stop="${i}" data-sf="spec"><option value=""${!sel ? ' selected' : ''}>時間指定なし</option>${['まで', '指定', '以降'].map((x) => `<option value="${x}"${sel === x ? ' selected' : ''}>${x}</option>`).join('')}</select>`
  const packOpts = ['パレット', 'バラ', 'カゴ', 'フレコン', 'コンテナ', '指定しない'] // 2026-08-25 オーナー決
  const stops = stopsOf(f)
  const runIdx = stops.indexOf(firstPick(f))
  const st = statusLabel(f.status, f.tripId)
  const stopCard = (s, i) => {
    const drop = s.role === 'drop'
    const canDel = (drop ? dropsOf(f).length : picksOf(f).length) > 1
    return `
    <div class="dp-pt">
      <div class="dp-pt-h${drop ? ' b' : ''}">
        <span>地点${i + 1}　${drop ? '卸し（着）' : '積み（発）'}</span>
        <span class="dp-pt-tools">
          <button type="button" class="dp-ptbtn" data-move="up" data-i="${i}"${i === 0 ? ' disabled' : ''}>↑</button>
          <button type="button" class="dp-ptbtn" data-move="down" data-i="${i}"${i === stops.length - 1 ? ' disabled' : ''}>↓</button>
          <button type="button" class="dp-ptbtn" data-role="${i}">${drop ? '積地に' : '着地に'}</button>
          <button type="button" class="dp-ptbtn" data-del="${i}"${canDel ? '' : ' disabled'}>×</button>
        </span>
      </div>
      <div class="dp-pt-b">
        <div class="dp-grid3">
          ${field('日付' + (i === runIdx ? '（運行日）' : ''), `<input type="date" data-stop="${i}" data-sf="date" value="${esc(s.date || '')}">`)}
          ${field('時間', `<input type="time" data-stop="${i}" data-sf="time" value="${esc(s.time || '')}">`)}
          ${field('時間指定', specSel(i, s.spec))}
        </div>
        <div style="margin-top:8px">${field('所名（拠点名）', `<input data-stop="${i}" data-sf="name" value="${esc(s.name || '')}">`)}</div>
        <div class="dp-grid3" style="margin-top:8px">
          ${field('都道府県', prefSel(i, s.pref))}
          ${field('市区町村', `<input data-stop="${i}" data-sf="city" value="${esc(s.city || '')}">`)}
          ${field('番地', `<input data-stop="${i}" data-sf="addr" value="${esc(s.addr || '')}">`)}
        </div>
        <div style="margin-top:8px">${field('建物名', `<input data-stop="${i}" data-sf="bldg" value="${esc(s.bldg || '')}">`)}</div>
        <details class="dp-more"${(s.contact || s.tel || s.note) ? ' open' : ''}>
          <summary>連絡先・軒先条件</summary>
          <div class="dp-grid" style="margin-top:6px">
            ${field('連絡先（名前）', `<input data-stop="${i}" data-sf="contact" value="${esc(s.contact || '')}">`)}
            ${field('連絡先（電話）', `<input data-stop="${i}" data-sf="tel" value="${esc(s.tel || '')}">`)}
          </div>
          <div style="margin-top:6px">${field('軒先条件', `<input data-stop="${i}" data-sf="note" value="${esc(s.note || '')}">`)}</div>
        </details>
      </div>
    </div>`
  }
  const atts = (f.attachments || []).map((a) => {
    const name = esc(a.filename || a.path || '添付')
    if (a.path && supabase) return `<a href="#" data-att="${esc(a.path)}">${name}</a>`
    return `<span>${name}</span>`
  }).join('')
  return `
  <div class="dp-modal" id="uk-modal">
    <div class="dp-card wide">
      <div class="dp-card-h">受付 ${f.mode === 'add' ? '新規' : esc(f.id)}
        <span class="uk-pill ${st.k}">${esc(st.t)}</span>
        <span class="dp-note">${f.source === 'email' ? 'メール取込' : '手入力'}</span>
      </div>
      <div class="dp-card-scroll">
        <div class="dp-seg" style="margin:2px 2px 12px">
          <button data-kind="own" class="${own ? 'on' : ''}">自社便</button>
          <button data-kind="charter" class="${!own ? 'on' : ''}">傭車</button>
        </div>
        <div class="dp-form2">
          <div class="dp-main">
            ${(f.fromEmail || f.subject || f.bodyText) ? `
            <div class="dp-sec"><div class="dp-sec-h">メール証跡</div>
              <div class="uk-mail">${esc([f.fromEmail && ('差出人: ' + f.fromEmail), f.subject && ('件名: ' + f.subject), f.bodyText].filter(Boolean).join('\n'))}</div>
            </div>` : ''}
            <div class="dp-sec"><div class="dp-sec-h">写真・PDF</div>
              ${atts ? `<div class="uk-att">${atts}</div>` : ''}
              ${(f.pendingFiles || []).map((p) => `<span class="uk-pend">保存中 ${esc(p.name || 'ファイル')}</span>`).join('')}
              <div><button type="button" class="dp-btn ghost" id="uk-files-btn">写真・PDFを追加</button>
                <input class="uk-file" type="file" id="uk-files" accept="${EVIDENCE_ACCEPT}" multiple hidden>
                <button type="button" class="dp-btn" id="uk-extract"${(f.attachments || []).some((a) => a && a.path) ? '' : ' disabled'}>このファイルから下書き</button></div>
              <div class="dp-hint">選んだ時点で保存されます（25MBまで）。「このファイルから下書き」で空欄だけ埋めます。数字の読み違いは直してから「取込する」。未入力のまま取込はできません。</div>
              ${f.err ? `<div class="dp-err" style="margin-top:8px">${esc(f.err)}</div>` : ''}
            </div>
            <div class="dp-sec" id="sec-nushi"><div class="dp-sec-h">荷主情報</div><div class="dp-grid">
              ${field('得意先', `<div class="dp-combo" data-combo="cust"><input data-party="cust" value="${esc(f.customerName || '')}" placeholder="コード または 会社名" autocomplete="off"><div class="dp-combo-list" hidden></div></div>`)}
              ${field('担当', `<select data-f="staff"><option value=""></option>${staffOpts.map((s) => `<option value="${esc(s)}"${s === f.staff ? ' selected' : ''}>${esc(s)}</option>`).join('')}</select>`)}
            </div></div>
            <div class="dp-sec"><div class="dp-sec-h">実運送体制管理簿</div>
              <div class="dp-radio" data-radio>
                ${['存在しない', '存在する', 'わからない'].map((o) => `<label class="${f.prime === o ? 'on' : ''}"><input type="radio" name="uk-prime" data-f="prime" value="${o}"${f.prime === o ? ' checked' : ''}>${o}</label>`).join('')}
              </div>
            </div>
            <div class="dp-sec" id="sec-route"><div class="dp-sec-h">ルートの設定</div>
              ${stops.map((s, i) => stopCard(s, i)).join('')}
              <div class="dp-addrow">
                <button type="button" class="dp-addbtn pick" data-add="pick">＋ 積地を追加</button>
                <button type="button" class="dp-addbtn drop" data-add="drop">＋ 着地を追加</button>
              </div>
            </div>
            <div class="dp-sec" id="sec-sha"><div class="dp-sec-h">希望車種</div>
              ${field('車種', vehicleTypeInput('data-f="vehicleClass"', f.vehicleClass, U.vtypes, 'uk-vtypes'))}
            </div>
            <div class="dp-sec" id="sec-nimotsu"><div class="dp-sec-h">荷物情報</div>
              ${field('品名', `<input data-f="item" value="${esc(f.item)}" placeholder="例）印刷物">`)}
              <div class="dp-fld" style="margin-top:9px"><span class="dp-lab">荷姿</span>
                <div class="dp-radio" data-radio>
                  ${packOpts.map((o) => { const v = o === '指定しない' ? '' : o; return `<label class="${(f.packing || '') === v ? 'on' : ''}"><input type="radio" name="uk-pack" data-f="packing" value="${v}"${(f.packing || '') === v ? ' checked' : ''}>${o}</label>` }).join('')}
                </div>
              </div>
              <div class="dp-grid3" style="margin-top:9px">
                ${field('個数', `<input type="number" data-f="qty" class="num" value="${esc(f.qty)}">`)}
                ${field('重量(kg)', `<input type="number" data-f="weightKg" class="num" value="${esc(f.weightKg)}">`)}
                ${field('容積(m³)', `<input type="number" data-f="volumeM3" class="num" value="${esc(f.volumeM3)}">`)}
              </div>
              <div class="dp-grid" style="margin-top:9px">
                ${field('伝票番号', `<input data-f="slipNo" value="${esc(f.slipNo)}">`)}
                ${field('荷物メモ', `<input data-f="cargoNote" value="${esc(f.cargoNote)}">`)}
              </div>
            </div>
            <div class="dp-sec" id="sec-tanto"><div class="dp-sec-h">${own ? '乗務員（自社便）' : '協力会社・実運送'}</div><div class="dp-grid">
              ${own
                ? field('自社乗務員', `<div class="dp-combo" data-combo="drv"><input data-party="drv" value="${esc(f.driverName || '')}" placeholder="コード または 氏名" autocomplete="off"><div class="dp-combo-list" hidden></div></div>`)
                : field('協力会社', `<div class="dp-combo" data-combo="part"><input data-party="part" value="${esc(f.partnerName || '')}" placeholder="コード または 会社名" autocomplete="off"><div class="dp-combo-list" hidden></div></div>`)}
              ${own ? field('車番', `<input data-f="carNo" value="${esc(f.carNo)}">`) : field('実運送会社', `<input data-f="carrier" value="${esc(f.carrier)}">`)}
              ${own ? field('電話', `<input data-f="tel" value="${esc(f.tel)}">`) : field('傭車乗務員', `<input data-f="youshaDriver" value="${esc(f.youshaDriver)}">`)}
              ${own ? '' : field('電話', `<input data-f="tel" value="${esc(f.tel)}">`)}
            </div></div>
            <div class="dp-sec" id="sec-kingaku"><div class="dp-sec-h">金額・締め</div><div class="dp-grid">
              ${field('運賃（受注）', `<input type="number" data-f="fare" class="num" value="${esc(f.fare)}">`)}
              ${field('請通行料', `<input type="number" data-f="tollBill" class="num" value="${esc(f.tollBill)}">`)}
              ${field('請求確定区分', `<select data-f="billFixed"><option value=""></option><option value="速報"${f.billFixed === '速報' ? ' selected' : ''}>速報</option><option value="確定"${f.billFixed === '確定' ? ' selected' : ''}>確定</option></select>`)}
              ${field('売上日', `<input type="date" data-f="salesDate" value="${esc(f.salesDate)}">`)}
              ${field('受領書回収日', `<input type="date" data-f="receiptDate" value="${esc(f.receiptDate)}">`)}
              ${field('備考①', `<input data-f="memo1" value="${esc(f.memo1)}">`)}
              ${field('備考②', `<input data-f="memo2" value="${esc(f.memo2)}">`)}
            </div>
            <div class="dp-hint" style="margin-top:8px">下払い金額・支払通行料はこの画面には出しません（社内の配車ボードで入力）。</div>
            </div>
            ${f.err ? `<div class="dp-err">${esc(f.err)}</div>` : ''}
          </div>
          <aside class="dp-side" id="uk-check">${sidePanel(f)}</aside>
        </div>
      </div>
      <div class="dp-card-f">
        <button class="dp-btn ghost" id="uk-copy">リンクをコピー</button>
        <button class="dp-btn ghost" id="uk-mail">メール下書き</button>
        ${f.status !== 'formal' && !f.tripId ? `<button class="dp-btn ok" id="uk-formal">正式にする</button>` : ''}
        ${!f.tripId ? `<button class="dp-btn primary" id="uk-dispatch">取込する</button>` : `<span class="dp-note">取込済 ${esc(f.tripId)}</span>`}
        <span style="flex:1"></span>
        ${f.id ? `<button class="dp-btn ghost" id="uk-del">削除</button>` : ''}
        <button class="dp-btn" id="uk-cancel">閉じる</button>
        <button class="dp-btn primary" id="uk-save">${esc(U.saving || '保存')}</button>
      </div>
    </div>
  </div>`
}

function setupCombo(box) {
  const which = box.dataset.combo
  const isDrv = which === 'drv'
  const src = which === 'cust' ? U.cust : which === 'part' ? U.part : U.drv
  const input = box.querySelector('input')
  const list = box.querySelector('.dp-combo-list')
  const nmeOf = (c) => isDrv ? (c.name || '') : (c.formal || c.name || '')
  const disp = (c) => isDrv ? String(c.code != null ? c.code : (c.id || '')) : `${c.code != null ? c.code : ''}${c.branchNo != null && c.branchNo !== '' ? '-' + c.branchNo : ''}`
  const arr = (src || []).slice().sort(byCode)
  const setId = (id, nm) => {
    if (which === 'cust') { U.form.customerId = id; U.form.customerName = nm }
    else if (which === 'part') { U.form.partnerId = id; U.form.partnerName = nm }
    else { U.form.driverId = id; U.form.driverName = nm }
  }
  let cur = [], hi = -1
  const place = () => { const r = input.getBoundingClientRect(); list.style.left = r.left + 'px'; list.style.top = (r.bottom + 3) + 'px'; list.style.width = r.width + 'px' }
  const hide = () => { list.hidden = true; hi = -1 }
  const pick = (c) => { setId(c.id, nmeOf(c)); input.value = `${disp(c)}　${nmeOf(c)}`; hide() }
  const render = (filter) => {
    const s = String(filter || '').trim().toLowerCase()
    cur = arr.filter((c) => { const nm = String(nmeOf(c)).toLowerCase(); return !s || nm.includes(s) || disp(c).toLowerCase().includes(s) }).slice(0, 200)
    hi = cur.length ? 0 : -1
    place(); list.hidden = false
    list.innerHTML = cur.length
      ? cur.map((c, i) => `<div class="dp-combo-row${i === hi ? ' active' : ''}" data-i="${i}"><span class="cc">${esc(disp(c))}</span><span>${esc(nmeOf(c))}</span></div>`).join('')
      : '<div class="dp-combo-empty">一致なし（このまま自由記入）</div>'
  }
  input.addEventListener('focus', () => { render(''); try { input.select() } catch (e) {} })
  input.addEventListener('input', () => { setId('', String(input.value || '').trim()); render(input.value) })
  input.addEventListener('keydown', (e) => {
    if (list.hidden) return
    if (e.key === 'ArrowDown') { hi = Math.min(hi + 1, cur.length - 1); render(input.value); e.preventDefault() }
    else if (e.key === 'ArrowUp') { hi = Math.max(hi - 1, 0); render(input.value); e.preventDefault() }
    else if (e.key === 'Enter' && cur[hi]) { pick(cur[hi]); e.preventDefault() }
    else if (e.key === 'Escape') hide()
  })
  list.addEventListener('mousedown', (e) => { const row = e.target.closest('.dp-combo-row'); if (!row) return; e.preventDefault(); const c = cur[Number(row.dataset.i)]; if (c) pick(c) })
  input.addEventListener('blur', () => setTimeout(hide, 160))
}

function formDoc(f) {
  const p0 = firstPick(f), dN = lastDrop(f)
  const runDate = (p0 && p0.date) || f.date || ''
  const cust = f.customerId ? U.custById[f.customerId] : null
  const cleanStops = stopsOf(f).map((s) => ({ role: s.role === 'drop' ? 'drop' : 'pick', name: s.name || '', pref: s.pref || '', city: s.city || '', addr: s.addr || '', bldg: s.bldg || '', date: s.date || '', time: s.time || '', spec: s.spec || '', contact: s.contact || '', tel: s.tel || '', note: s.note || '' }))
  const doc = sanitizeForCustomer({
    source: f.source || 'manual', status: f.status || 'sashi', token: f.token || genToken(),
    date: runDate, unloadDate: (dN && dN.date) || runDate, month: runDate ? runDate.slice(0, 7) : '',
    staff: f.staff || '', kind: f.kind,
    customerName: cust ? (cust.name || '') : (f.customerName || ''),
    customerFormal: cust ? (cust.formal || cust.name || '') : (f.customerName || ''),
    origin: originStr(f), dest: destStr(f), item: f.item || '', vehicleClass: f.vehicleClass || '',
    stops: cleanStops, cargoNote: f.cargoNote || '',
    packing: f.packing || '', qty: Number(f.qty) || 0, weightKg: Number(f.weightKg) || 0, volumeM3: Number(f.volumeM3) || 0,
    prime: f.prime || '', slipNo: f.slipNo || '',
    fare: Number(f.fare) || 0, tollBill: Number(f.tollBill) || 0,
    billFixed: f.billFixed || '', salesDate: f.salesDate || '', receiptDate: f.receiptDate || '', memo1: f.memo1 || '', memo2: f.memo2 || '',
    driverName: f.driverName || '', carNo: f.carNo || '', tel: f.tel || '',
    partnerName: f.partnerName || '', carrier: f.carrier || '', youshaDriver: f.youshaDriver || '',
    attachments: f.attachments || [], fromEmail: f.fromEmail || '', subject: f.subject || '', bodyText: f.bodyText || '',
    tripId: f.tripId || '', updatedAt: new Date().toISOString(),
  })
  if (cust) { doc.customerCode = cust.code; if (cust.branchNo != null) doc.customerBranchNo = cust.branchNo }
  if (f.kind === 'own') {
    const drv = f.driverId ? U.drvById[f.driverId] : null
    if (drv) { doc.driverName = drv.name || doc.driverName; doc.driverCode = String(drv.code || drv.id) }
  } else {
    const pt = f.partnerId ? U.partById[f.partnerId] : null
    if (pt) { doc.partnerName = pt.name || doc.partnerName; doc.partnerFormal = pt.formal || pt.name || ''; doc.partnerCode = pt.code }
  }
  return doc
}

async function saveForm(extra) {
  const f = U.form
  if (!f) return null
  f.err = ''
  const id = f.id || newId(runDateOf(f))
  f.id = id
  const pending = (f.pendingFiles || []).slice()
  let doc = Object.assign(formDoc(f), extra || {})
  try {
    U.saving = pending.length ? '画像を保存中…' : '保存中…'
    const saveBtn = U.el && U.el.querySelector('#uk-save')
    if (saveBtn) saveBtn.textContent = U.saving
    const first = { ...doc }
    if (pending.length && !(first.attachments && first.attachments.length)) delete first.attachments
    await upsert('requests', id, first)
    if (pending.length) {
      const uploaded = await uploadEvidenceFiles(id, pending)
      doc = mergeEvidenceAttachments(doc, uploaded)
      f.pendingFiles = []
      await upsert('requests', id, { attachments: doc.attachments, status: doc.status, updatedAt: doc.updatedAt })
    }
    const i = U.rows.findIndex((x) => x.id === id)
    const merged = { id, ...(i >= 0 ? U.rows[i] : {}), ...doc }
    if (i >= 0) U.rows[i] = merged; else U.rows.push(merged)
    const filledKeys = f.filledKeys
    U.form = rowToForm(merged)
    if (filledKeys && filledKeys.length) U.form.filledKeys = filledKeys
    U.saving = '保存しました'
    paint()
    setTimeout(() => { if (U.saving === '保存しました') { U.saving = ''; paint() } }, 1400)
    return merged
  } catch (e) {
    U.saving = ''
    f.err = explainEvidenceError(e)
    paint()
    return null
  }
}

function wireForm() {
  const el = U.el
  el.querySelectorAll('#uk-modal [data-kind]').forEach((b) => b.addEventListener('click', () => { U.form.kind = b.dataset.kind; paint() }))
  el.querySelectorAll('#uk-modal [data-f]').forEach((inp) => {
    const ev = (inp.tagName === 'SELECT' || inp.type === 'radio') ? 'change' : 'input'
    inp.addEventListener(ev, () => { U.form[inp.dataset.f] = inp.value })
  })
  el.querySelectorAll('#uk-modal [data-stop]').forEach((inp) => {
    const ev = inp.tagName === 'SELECT' ? 'change' : 'input'
    inp.addEventListener(ev, () => { const s = stopsOf(U.form)[Number(inp.dataset.stop)]; if (s) s[inp.dataset.sf] = inp.value })
  })
  el.querySelectorAll('#uk-modal [data-add]').forEach((b) => b.addEventListener('click', () => { U.form.stops = stopsOf(U.form).concat([blankStop(b.dataset.add)]); paint() }))
  el.querySelectorAll('#uk-modal [data-del]').forEach((b) => b.addEventListener('click', () => {
    const i = Number(b.dataset.del), st = stopsOf(U.form), s = st[i]; if (!s) return
    if ((s.role === 'drop' ? dropsOf(U.form) : picksOf(U.form)).length <= 1) return
    st.splice(i, 1); paint()
  }))
  el.querySelectorAll('#uk-modal [data-move]').forEach((b) => b.addEventListener('click', () => {
    const i = Number(b.dataset.i), st = stopsOf(U.form), j = i + (b.dataset.move === 'up' ? -1 : 1)
    if (j < 0 || j >= st.length) return
    const t = st[i]; st[i] = st[j]; st[j] = t; paint()
  }))
  el.querySelectorAll('#uk-modal [data-role]').forEach((b) => b.addEventListener('click', () => {
    const s = stopsOf(U.form)[Number(b.dataset.role)]; if (!s) return
    s.role = s.role === 'drop' ? 'pick' : 'drop'; paint()
  }))
  el.querySelectorAll('#uk-modal .dp-radio').forEach((grp) => grp.addEventListener('change', () => {
    grp.querySelectorAll('label').forEach((lab) => { const r = lab.querySelector('input'); lab.classList.toggle('on', !!(r && r.checked)) })
  }))
  el.querySelectorAll('#uk-modal [data-goto]').forEach((g) => g.addEventListener('click', () => { const t = el.querySelector('#' + g.dataset.goto); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }) }))
  el.querySelectorAll('#uk-modal .dp-combo').forEach(setupCombo)
  const cancel = el.querySelector('#uk-cancel'); if (cancel) cancel.addEventListener('click', () => { U.form = null; paint() })
  const del = el.querySelector('#uk-del')
  if (del) del.addEventListener('click', async () => {
    const f = U.form
    if (!f.id) return
    const extra = f.tripId ? `\n配車ボードの ${f.tripId} は残ります。配車側は「取消」してください。` : ''
    if (!confirm(`この受付を削除しますか？${extra}`)) return
    try {
      U.saving = '削除中…'; paint()
      await remove('requests', f.id)
      U.rows = U.rows.filter((x) => x.id !== f.id)
      U.form = null
      U.saving = '削除しました'
      paint()
      setTimeout(() => { if (U.saving === '削除しました') { U.saving = ''; paint() } }, 1400)
    } catch (e) {
      U.saving = ''
      if (U.form) U.form.err = '削除に失敗しました'
      paint()
    }
  })
  const modal = el.querySelector('#uk-modal'); if (modal) modal.addEventListener('mousedown', (e) => { if (e.target === modal) { U.form = null; paint() } })
  const save = el.querySelector('#uk-save'); if (save) save.addEventListener('click', () => saveForm())
  const files = el.querySelector('#uk-files')
  const filesBtn = el.querySelector('#uk-files-btn')
  if (filesBtn && files) filesBtn.addEventListener('click', () => files.click())
  if (files) files.addEventListener('change', async () => {
    const add = Array.from(files.files || [])
    files.value = ''
    if (!add.length || !U.form) return
    U.form.pendingFiles = (U.form.pendingFiles || []).concat(add)
    await saveForm()
  })
  const extractBtn = el.querySelector('#uk-extract')
  if (extractBtn) extractBtn.addEventListener('click', async () => {
    const f = U.form
    const att = [...(f.attachments || [])].reverse().find((a) => a && a.path)
    if (!att) { f.err = '先に写真・PDFを保存してください'; paint(); return }
    try {
      U.saving = '読み取り中…'
      extractBtn.disabled = true
      extractBtn.textContent = '読み取り中…'
      const { draft, preview } = await extractDraftFromPath(att.path, att.filename)
      let { form: next, filled } = applyExtractedDraft(U.form, coalesceDraftWithFilename(draft, att.filename))
      let party = matchMasterParty(next.customerName, U.cust)
      if (party) {
        next.customerId = party.id
        next.customerName = party.formal || party.name || next.customerName
        if (!filled.includes('customerName')) filled.push('customerName')
      }
      if (next.vehicleClass) next.vehicleClass = matchVehicleClass(next.vehicleClass, U.vtypes)
      // 過去便は「空欄の補完」のみ。読めた値・マスタ確定値は上書きしない。
      // 補完元は trips（実績）だけ。受付一覧（誤読が残り得る）は使わない
      const hist = suggestMissingFromHistory(next, U.trips || [])
      if (hist.customerName && !next.customerName) {
        const histParty = matchMasterParty(hist.customerName, U.cust)
        if (histParty) {
          next.customerId = histParty.id
          next.customerName = histParty.formal || histParty.name || hist.customerName
          party = histParty
        } else {
          next.customerName = hist.customerName
        }
        if (!filled.includes('customerName')) filled.push('customerName')
      }
      if (hist.origin) {
        const pick = (next.stops || []).find((s) => s.role === 'pick') || (next.stops || [])[0]
        if (pick && !pick.name) {
          pick.name = hist.origin
          if (!filled.includes('origin')) filled.push('origin')
        }
        if (!next.origin) next.origin = hist.origin
      }
      if (hist.vehicleClass || hist.item || hist.packing || hist.fare) {
        const more = applyExtractedDraft(next, hist)
        next = more.form
        filled = filled.concat(more.filled.filter((k) => !filled.includes(k)))
      }
      if (!filled.length) {
        U.saving = ''
        const hint = String(preview || '').replace(/\s+/g, ' ').trim().slice(0, 180)
        U.form.err = hint
          ? `読み取った内容を枠に入れられませんでした。手入力してください。 ${hint}`
          : '読み取った内容を枠に入れられませんでした。手入力してください。'
        paint()
        return
      }
      U.form = Object.assign(next, { filledKeys: filled, err: '' })
      U.saving = `下書き ${filled.length} 項目`
      await saveForm()
    } catch (e) {
      U.saving = ''
      if (U.form) U.form.err = explainEvidenceError(e)
      paint()
    }
  })
  ;(U.form && U.form.filledKeys || []).forEach((k) => {
    el.querySelectorAll(`#uk-modal [data-f="${k}"]`).forEach((n) => n.classList.add('uk-draft'))
    if (k === 'origin') {
      const pick = el.querySelector('#uk-modal [data-stop="0"][data-sf="name"]')
      if (pick) pick.classList.add('uk-draft')
    }
  })
  const copy = el.querySelector('#uk-copy')
  if (copy) copy.addEventListener('click', async () => {
    const saved = await saveForm()
    if (!saved) return
    const url = publicLink(saved.token)
    try { await navigator.clipboard.writeText(url); U.saving = 'リンクをコピーしました'; paint() } catch { prompt('このURLをコピー', url) }
  })
  const mail = el.querySelector('#uk-mail')
  if (mail) mail.addEventListener('click', async () => {
    const saved = await saveForm()
    if (!saved) return
    const url = publicLink(saved.token)
    const to = saved.fromEmail || ''
    const subj = '【エースジャパン】運行依頼のご入力'
    const body = `お世話になっております。エースジャパンです。\n下記リンクより依頼内容をご入力ください。\n\n${url}\n`
    location.href = `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(subj)}&body=${encodeURIComponent(body)}`
  })
  const formal = el.querySelector('#uk-formal')
  if (formal) formal.addEventListener('click', () => saveForm({ status: 'formal' }))
  const disp = el.querySelector('#uk-dispatch')
  if (disp) disp.addEventListener('click', async () => {
    const f = U.form
    const miss = missingRequired(f)
    if (miss.length) { f.err = '未入力があるため取り込めません: ' + miss.join('、'); paint(); return }
    const saved = await saveForm()
    if (!saved) return
    const trip = requestToTrip(saved)
    try {
      U.saving = '配車へ送信中…'; paint()
      await upsert('trips', trip.id, trip)
      await upsert('requests', saved.id, { tripId: trip.id, status: 'formal', dispatchedAt: new Date().toISOString() })
      saved.tripId = trip.id; saved.status = 'formal'
      const i = U.rows.findIndex((x) => x.id === saved.id)
      if (i >= 0) Object.assign(U.rows[i], { tripId: trip.id, status: 'formal' })
      U.form = rowToForm({ ...saved, tripId: trip.id, status: 'formal' })
      U.saving = '配車ボードへ取り込みました'
      paint()
    } catch (e) { U.saving = ''; U.form.err = '取込に失敗しました'; paint() }
  })
  el.querySelectorAll('#uk-modal [data-att]').forEach((a) => a.addEventListener('click', async (ev) => {
    ev.preventDefault()
    const path = a.getAttribute('data-att')
    if (!supabase || !path) return
    try {
      const { data, error } = await supabase.storage.from('request-evidence').createSignedUrl(path, 3600)
      if (error) throw error
      if (data && data.signedUrl) window.open(data.signedUrl, '_blank')
    } catch (e) { alert('添付を開けませんでした') }
  }))
}

async function saveListCell(id, key, value) {
  if (U.painting) return
  const row = U.rows.find((x) => x.id === id)
  if (!row || !U.online) return
  const shown = key === 'customerName' ? (row.customerFormal || row.customerName || '')
    : key === 'carrier' ? (row.carrier || row.partnerFormal || row.partnerName || '')
    : key === 'driverName' ? (row.driverName || row.youshaDriver || '')
    : key === 'fare' ? String(row.fare || '')
    : String(row[key] || '')
  if (key === 'fare') {
    if ((Number(shown) || 0) === (Number(value) || 0)) return
  } else if (shown === String(value || '')) return
  const next = applyListPatch(row, key, value)
  const payload = { ...next }
  delete payload.attachments
  delete payload.pendingFiles
  const note = () => U.el && U.el.querySelector('#uk-save-note')
  try {
    U.saving = '保存中…'
    if (note()) note().textContent = '保存中…'
    await upsert('requests', id, payload)
    const i = U.rows.findIndex((x) => x.id === id)
    if (i >= 0) U.rows[i] = { ...U.rows[i], ...next, id, attachments: U.rows[i].attachments }
    U.saving = '保存しました'
    if (note()) note().textContent = '保存しました'
    setTimeout(() => {
      if (U.saving === '保存しました') {
        U.saving = ''
        if (note()) note().textContent = ''
      }
    }, 1200)
  } catch (e) {
    U.saving = ''
    if (note()) note().textContent = '保存に失敗'
  }
}

function cellInp(id, key, val, type) {
  const n = key === 'fare'
  const v = n ? (val ? String(val) : '') : (val || '')
  return `<td${n ? ' class="n"' : ''}><input class="uk-cell" data-id="${esc(id)}" data-k="${esc(key)}" type="${type || (n ? 'number' : 'text')}" value="${esc(v)}"></td>`
}

function visibleRows() {
  const q = String(U.q || '').trim().toLowerCase()
  return U.rows.filter((r) => {
    const st = r.tripId ? 'sent' : (r.status === 'formal' ? 'formal' : 'sashi')
    if (U.filter !== 'all' && st !== U.filter) return false
    if (!q) return true
    const blob = [r.id, r.customerName, r.customerFormal, r.origin, r.dest, r.item, r.driverName, r.carNo, r.partnerName, r.carrier].join(' ').toLowerCase()
    return blob.includes(q)
  }).sort((a, b) => String(b.date || b.createdAt || '').localeCompare(String(a.date || a.createdAt || '')))
}

function paint() {
  const el = U.el
  U.painting = true
  const rows = visibleRows()
  const fil = [['all', '全部'], ['sashi', '仮受付'], ['formal', '正式'], ['sent', '配車済']]
    .map(([id, lab]) => `<button data-fil="${id}" class="${U.filter === id ? 'on' : ''}">${lab}</button>`).join('')
  const trs = rows.map((r) => {
    const st = statusLabel(r.status, r.tripId)
    return `<tr data-id="${esc(r.id)}">
      <td><span class="uk-pill ${st.k}" data-open="${esc(r.id)}">${esc(st.t)}</span></td>
      ${cellInp(r.id, 'date', r.date, 'date')}
      ${cellInp(r.id, 'customerName', r.customerFormal || r.customerName || '')}
      ${cellInp(r.id, 'origin', r.origin || '')}
      ${cellInp(r.id, 'dest', r.dest || '')}
      ${cellInp(r.id, 'vehicleClass', r.vehicleClass || '')}
      ${cellInp(r.id, 'item', r.item || '')}
      ${cellInp(r.id, 'fare', r.fare || '')}
      ${cellInp(r.id, 'carrier', r.carrier || r.partnerFormal || r.partnerName || '')}
      ${cellInp(r.id, 'driverName', r.driverName || r.youshaDriver || '')}
      ${cellInp(r.id, 'carNo', r.carNo || '')}
    </tr>`
  }).join('')
  el.innerHTML = `
  <div class="uk">
    <div class="uk-bar">
      <div class="dp-seg">${fil}</div>
      <input type="search" id="uk-q" placeholder="得意先・発着・品名で検索" value="${esc(U.q)}">
      <button class="dp-btn primary" id="uk-new">＋ 新規受付</button>
      <span class="dp-note">セルを直して Enter / 枠外クリックで保存。状態をクリックで詳細（写真・取込）。</span>
      <span class="dp-note" id="uk-save-note">${esc(U.saving || '')}</span>
    </div>
    <div class="uk-ss-wrap">
      <table class="uk-ss">
        <thead><tr><th>状態</th><th>運行日</th><th>得意先</th><th>発地</th><th>着地</th><th>車種</th><th>品名</th><th class="n">運賃</th><th>実運送会社</th><th>乗務員</th><th>車番</th></tr></thead>
        <tbody>${trs || `<tr><td colspan="11" style="text-align:center;color:var(--text);padding:18px">まだ受付がありません</td></tr>`}</tbody>
      </table>
    </div>
    ${U.form ? renderForm() : ''}
  </div>`
  el.querySelectorAll('[data-fil]').forEach((b) => b.addEventListener('click', () => { U.filter = b.dataset.fil; paint() }))
  const q = el.querySelector('#uk-q')
  if (q) q.addEventListener('keydown', (e) => { if (e.key === 'Enter') { U.q = q.value; paint() } })
  if (q) q.addEventListener('blur', () => { if (U.q !== q.value) { U.q = q.value; paint() } })
  const neu = el.querySelector('#uk-new'); if (neu) neu.addEventListener('click', () => { U.form = blankForm(); paint() })
  // 配車済（tripId あり）は requests の古いスナップショットではなく配車フォームを正として開く
  // （既存の非対称の是正。design doc「既存の非対称の是正」節・PR③）。requests のデータは変更しない。
  el.querySelectorAll('.uk-ss [data-open]').forEach((p) => p.addEventListener('click', () => {
    const row = U.rows.find((x) => x.id === p.getAttribute('data-open')); if (!row) return
    if (row.tripId) { location.hash = '#/dispatch?open=' + encodeURIComponent(row.tripId); return }
    U.form = rowToForm(row); paint()
  }))
  el.querySelectorAll('.uk-ss input.uk-cell').forEach((inp) => {
    inp.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); inp.blur() } })
    inp.addEventListener('blur', () => saveListCell(inp.dataset.id, inp.dataset.k, inp.value))
  })
  if (U.form) wireForm()
  U.painting = false
}

// 取得失敗の主表示。一覧・フォーム・受付導線は描かない（受付0件ではないため）
function paintFetchError() {
  U.el.innerHTML = '<div class="uk"><div class="ct-state is-error"><b class="ct-state__t">受付ボードを読み込めませんでした</b><span>登録済みの受付を取得できていません。この状態では新規受付・編集も保存できません。接続を確認して再試行してください</span><button type="button" class="btn" id="uk-retry">再試行</button></div></div>'
  const retry = U.el.querySelector('#uk-retry'); if (retry) retry.addEventListener('click', () => { renderIntake(U.el, U.ctx) })
}

export async function renderIntake(el, ctx = {}) {
  styleOnce()
  U.el = el; U.ctx = ctx; U.user = ctx.user || null; U.form = null; U.saving = ''
  U.online = !ctx.demo && supabaseReady
  U.fetchError = false
  el.innerHTML = '<div class="dp-note" style="padding:16px">読込中…</div>'
  U.rows = []; U.cust = []; U.part = []; U.drv = []; U.trips = []
  if (U.online) {
    try {
      const [rows, cust, part, drv, vtypes, trips] = await Promise.all([
        listDocs('requests'), listDocs(COLLECTIONS.customers), listDocs(COLLECTIONS.partners), listDocs(COLLECTIONS.drivers), loadVehicleTypes(), listDocs(COLLECTIONS.trips),
      ])
      U.rows = rows || []; U.vtypes = vtypes || []; U.trips = trips || []
      U.cust = (cust || []).slice().sort(byCode); U.part = (part || []).slice().sort(byCode); U.drv = (drv || []).slice().sort(byCode)
      U.custById = idMap(U.cust); U.partById = idMap(U.part); U.drvById = idMap(U.drv)
      subscribeChanges('requests', ({ type, id, doc }) => {
        if (type === 'DELETE') U.rows = U.rows.filter((x) => x.id !== id)
        else if (doc) {
          const i = U.rows.findIndex((x) => x.id === id)
          const prev = i >= 0 ? U.rows[i] : null
          const keepAtt = (prev && prev.attachments && prev.attachments.length && !(doc.attachments && doc.attachments.length))
          const next = keepAtt ? { ...doc, attachments: prev.attachments } : doc
          if (i >= 0) U.rows[i] = next; else U.rows.push(next)
          if (U.form && U.form.id === id && keepAtt) U.form.attachments = prev.attachments
        }
        if (!U.form && !(U.el && U.el.querySelector('.uk-cell:focus'))) paint()
      })
    } catch (e) { U.online = false; U.fetchError = true }
  }
  // 取得失敗は「受付0件」ではない。黙って空の受付ボードを見せず is-error を主表示にする
  // （PR #52 と同型。intake は同梱サンプルを持たないため、必要なのはこの短絡だけ）。
  // 短絡は ?open= の解決より前。行が1件も無い＝開ける受付も無いため、成功時の挙動は不変
  if (U.fetchError) { paintFetchError(); return }
  // 配車・受注ボードから「開く」で飛んできた場合（#/intake?open=<id>）は、その受付を自動で開く。
  // 統合の第一歩（一覧の合成・導線）。データ・フォームは合流しない
  // （engineering-タクミ/docs/2026-08-25-受付配車受注統合-設計.md 方針5・PR②）。
  const openId = openIdFromHash(location.hash)
  if (openId) {
    const row = U.rows.find((x) => x.id === openId)
    if (row) U.form = rowToForm(row)
  }
  paint()
}
